import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Button } from '../../globalStyles';
import {
  InfoSec,
  InfoRow,
  InfoColumn,
  TextWrapper,
  TopLine,
  TopLine2,
  Heading,
  Subtitle,
  Subtitle1,
  ImgWrapper,
  Img
} from './InfoSection.elements';

function InfoSection({
  primary,
  lightBg,
  topLine,
  topLine2,
  lightTopLine,
  lightText,
  lightTextDesc,
  headline,
  description,
  descriptions,
  description1,
  description2,
  description3,
  buttonLabel,
  img,
  alt,
  imgStart,
  start,
  margin,
  buttonstate,
  infostate,
  video,
  padding,
  id,
  buttonstateblog,
  redirect,
  footer,
  infostateblog
}) {
  return (
    <>
      <InfoSec id={id} style={{ padding: padding }} lightBg={lightBg}>
        <Container style={{ marginTop: margin }}>
          <InfoRow imgStart={imgStart}>
            <InfoColumn>
              <TextWrapper>
                {topLine2 && <TopLine2 lightTopLine={lightText}>{topLine2}</TopLine2>}
                {topLine && <TopLine lightTopLine={lightTopLine}>{topLine}</TopLine>}
                <Heading lightText={lightText}>{headline}</Heading>
                {description && <Subtitle lightTextDesc={lightTextDesc}>{description}</Subtitle>}
                
                {infostate === true && (
                  <>
                    {descriptions && <Subtitle1 lightTextDesc={lightTextDesc}>{descriptions}</Subtitle1>}
                    {description1 && <Subtitle1 lightTextDesc={lightTextDesc}>{description1}</Subtitle1>}
                    {description2 && <Subtitle1 lightTextDesc={lightTextDesc}>{description2}</Subtitle1>}
                    {description3 && <Subtitle1 lightTextDesc={lightTextDesc}>{description3}</Subtitle1>}
                  </>
                )}
                
                {infostateblog === true && (
                  <>
                    {descriptions && <Subtitle lightTextDesc={lightTextDesc}>{descriptions}</Subtitle>}
                    {description1 && <Subtitle lightTextDesc={lightTextDesc}>{description1}</Subtitle>}
                    {description2 && <Subtitle lightTextDesc={lightTextDesc}>{description2}</Subtitle>}
                  </>
                )}
                
                {buttonstate === true ? (
                  <Link onClick={() => window.open('https://zangie.mounts.in/')}>
                    <Button big fontBig primary={primary}>
                      {buttonLabel}
                    </Button>
                  </Link>
                ) : null}
                
                {buttonstateblog === true ? (
                  <Button onClick={() => window.open(redirect)} big fontBig primary={primary}>
                    {buttonLabel}
                  </Button>
                ) : null}
                
                {footer && (
                  <Heading lightText={lightText} style={{ marginTop: '20px', fontSize: '1.25rem' }}>
                    {footer}
                  </Heading>
                )}
              </TextWrapper>
            </InfoColumn>
            <InfoColumn>
              <ImgWrapper start={start}>
                {video ? (
                  <iframe style={{ minWidth: "100%", height: 340, borderRadius: '12px', border: 'none' }} src="https://www.youtube.com/embed/aQEliLKfuno" title="mountscortex" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                ) : (
                  <Img src={img} alt={alt} />
                )}
              </ImgWrapper>
            </InfoColumn>
          </InfoRow>
        </Container>
      </InfoSec>
    </>
  );
}

export default InfoSection;
